import DropdownsApi from '../api/Dropdowns'
import {isEmpty} from 'lodash'

class Dropdowns {
  constructor({dropdown, name, cache = true, forceFetch = false}) {
    this.props = {
      dropdown,
      name,
      cache,
      forceFetch,
    }
    this.api = new DropdownsApi()
    this.suffix = 'dropdown'
    this.itemName = `${dropdown}_${name}_${this.suffix}`
    this.data = []
  }

  get = async forceFetch => {
    await this.set(forceFetch)
    return this.data
  }
  set = async (forceFetch = this.props.forceFetch) => {
    if (this.props.cache === true) {
      const cached = this.getCached()
      if (!isEmpty(cached) && forceFetch !== true) this.data = cached
      else {
        this.data = await this.fetch()
        this.cache()
      }
    } else {
      this.data = await this.fetch()
    }
  }
  fetch = async () => {
    return await this.api.read(this.props.dropdown, this.props.name)
  }
  cache = () => {
    sessionStorage.setItem(this.itemName, JSON.stringify(this.data))
  }
  getCached = () => {
    return JSON.parse(sessionStorage.getItem(this.itemName))
  }
}

export default Dropdowns
